export default __webpack_public_path__ + "2ac31ce156e78e19f6d1cdbe95e4d6cc.png";